(() => {
    const initStateReady = () => {
        document.body.addEventListener('click', function (event) {
            if (event.target.classList.contains('dropdownButton') || event.target.closest('.dropdownButton')) {
                const button = event.target.classList.contains('dropdownButton')
                    ? event.target
                    : event.target.closest('.dropdownButton');
                toggleDropdown(button);
            }
        });
    };

    const toggleDropdown = (event) => {
        event.classList.toggle('active-btn-color');

        const dropdownContainer = document.querySelector('#' + event.dataset.dropdownId);

        if (dropdownContainer) {
            dropdownContainer.classList.toggle('show');
        }

        const plusIcon = event.querySelector('#plus');
        const closeIcon = event.querySelector('#close');

        if (plusIcon) plusIcon.classList.toggle('hide');
        if (closeIcon) closeIcon.classList.toggle('hide');

        let searchFormFilter = event.closest('.dropdown');

        if (dropdownContainer && dropdownContainer.classList.contains('show')) {
            let newHeight = dropdownContainer.offsetHeight;
            if (newHeight < 100) {
                newHeight = 100;
            } else {
                newHeight = newHeight + 37;
            }
            if (searchFormFilter) {
                searchFormFilter.style.marginBottom = newHeight + 'px';
            }
        } else {
            if (searchFormFilter) {
                searchFormFilter.style.marginBottom = '5px';
            }
        }
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') {
            return;
        }

        initStateReady();
    });
})();
